module.exports = __webpack_public_path__ + "img/jiguang-propa.de518898.png";